/**
 * Contact page form injection and submission behavior.
 * Loaded only on contact page handles by the theme layouts.
 */
  // =============================================================================
  // Contact Page Form Injection
  // =============================================================================
  const ContactPageForm = {
    init: function() {
      // Check if we're on the contact-us page
      if (window.location.pathname.includes('/pages/contact-us') || window.location.pathname.includes('/pages/contact')) {
        this.injectContactForm();
      }
    },

    injectContactForm: async function() {
      const targetContainer = document.getElementById('contact-form');
        if (!targetContainer) {
          console.log('Contact form container not found');
          return;
        }

      // Get UTM parameters
      const utmData = getUtmParams();

      // Get device and browser information
      const deviceType = this.getDeviceType();
      const browserName = this.getBrowserName();

      // No IP pre-fetching - will be resolved on-demand during form submit

      // Create the form HTML
      const formHTML = `
        <div class="contact-page-form">
          <form id="pageContactForm" class="contact-form" onsubmit="handlePageContactFormSubmit(event)">
            <div class="contact-form-row">
            <div class="contact-form-field">
              <label class="field-label">Full Name</label>
              <input type="text" name="full_name" required>
            </div>
              <div class="contact-form-field">
                <label class="field-label">Email *</label>
                <input type="email" name="email" id="page-contact-email-input" required>
                <span id="page-contact-email-error" class="field-error" style="display: none; color: #ff3333; font-size: 12px; margin-top: 5px;">Please enter a valid email address (e.g., name@example.com)</span>
              </div>
            </div>

            <div class="contact-form-row">
              <div class="contact-form-field phone-field">
                <label class="field-label">Phone *</label>
                <div class="phone-input-container">
                  <span class="country-code-static" aria-hidden="true">+1</span>
                  <input type="hidden" name="country_code" value="+1">
                  <input type="tel" name="phone" id="page-contact-phone-input" required>
                </div>
                <span id="page-contact-phone-error" class="field-error" style="display: none; color: #ff3333; font-size: 12px; margin-top: 5px;">Please enter a valid phone number. Only digits, spaces, and + ( ) - . are allowed. At least 11 digits required, including the country code.</span>
              </div>
            </div>

            <div class="contact-form-row">
              <div class="contact-form-field full-width">
                <label class="field-label">Your Message</label>
                <textarea
                  name="body"
                  rows="4"
                  required
                ></textarea>
              </div>
            </div>

            <div class="contact-method-section">
              <label class="section-label">Preferred method of contact *</label>
              <div class="contact-method-options">
                <label class="radio-option">
                  <input type="radio" name="preferred_contact" value="email" required>
                  <span class="radio-text">Email</span>
                </label>
                <label class="radio-option">
                  <input type="radio" name="preferred_contact" value="call" required>
                  <span class="radio-text">Call</span>
                </label>
                <label class="radio-option">
                  <input type="radio" name="preferred_contact" value="sms" required>
                  <span class="radio-text">SMS</span>
                </label>
                <label class="radio-option">
                  <input type="radio" name="preferred_contact" value="no_preference" required>
                  <span class="radio-text">No Preference</span>
                </label>
              </div>
            </div>

            <div class="recaptcha-container">
              <div
                id="page-contact-recaptcha"
                class="g-recaptcha"
                data-sitekey="6LdtgPQqAAAAAEkslzcJ6caAt-FtU6gM5FNMKJyi"
              ></div>
              <span id="page-contact-recaptcha-error" style="color: red; display: none; font-size: 12px;"
                >Please complete the reCAPTCHA.</span
              >
            </div>

            <!-- Hidden fields -->
            <input type="hidden" name="product_title" value="General Contact">
            <input type="hidden" name="product_url" value="">
            <input type="hidden" name="form_type" value="contact_inquiry">
            <input type="hidden" name="contact[utm_source]" value="${utmData.utm_source || ''}">
            <input type="hidden" name="contact[utm_medium]" value="${utmData.utm_medium || ''}">
            <input type="hidden" name="contact[utm_campaign]" value="${utmData.utm_campaign || ''}">
            <input type="hidden" name="contact[gclid]" value="${utmData.gclid || ''}">
            <input type="hidden" name="contact[gbraid]" value="${utmData.gbraid || ''}">
            <input type="hidden" name="contact[wbraid]" value="${utmData.wbraid || ''}">
            <input type="hidden" name="contact[msclkid]" value="${utmData.msclkid || ''}">
            <input type="hidden" name="contact[device]" value="${deviceType}">
            <input type="hidden" name="contact[browser]" value="${browserName}">
            <input type="hidden" name="contact[ip_address]" id="contact-ip" value="">

            <button type="submit" class="contact-submit-btn">Submit</button>
          </form>
        </div>
      `;

      // Add the CSS styles
      this.addContactFormStyles();

      // Inject the form
      targetContainer.innerHTML = formHTML;

      // Setup email validation
      const emailInput = targetContainer.querySelector('#page-contact-email-input');
      const emailError = targetContainer.querySelector('#page-contact-email-error');
      if (emailInput && emailError) {
        emailInput.addEventListener('blur', function() {
          pageContactValidateEmailField(emailInput, emailError);
        });
        emailInput.addEventListener('input', function() {
          if (emailInput.value.trim() && pageContactValidateEmail(emailInput.value.trim())) {
            emailInput.classList.remove('error');
            emailError.style.display = 'none';
          }
        });
      }

      // Setup phone validation — block alphabets and invalid chars, validate on blur
      const phoneInput = targetContainer.querySelector('#page-contact-phone-input');
      const phoneError = targetContainer.querySelector('#page-contact-phone-error');
      if (phoneInput && phoneError) {
        phoneInput.addEventListener('keydown', function(e) {
          const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
          if (allowedKeys.includes(e.key)) return;
          if (/^[0-9]$/.test(e.key)) return;
          if (/^[ +().\-]$/.test(e.key)) return;
          e.preventDefault();
        });
        phoneInput.addEventListener('paste', function(e) {
          e.preventDefault();
          const pasted = (e.clipboardData || window.clipboardData).getData('text');
          const filtered = pasted.replace(/[^0-9 +().\-]/g, '');
          const start = this.selectionStart;
          const end = this.selectionEnd;
          this.value = this.value.substring(0, start) + filtered + this.value.substring(end);
        });
        phoneInput.addEventListener('blur', function() {
          if (phoneInput.value.trim()) {
            pageContactValidatePhoneField(phoneInput, phoneError);
          }
        });
        phoneInput.addEventListener('input', function() {
          const countryCode = phoneInput.form.querySelector('[name="country_code"]')?.value || '';
          if (phoneInput.value.trim() && pageContactValidatePhone(phoneInput.value.trim(), countryCode)) {
            phoneInput.classList.remove('error');
            phoneError.style.display = 'none';
          }
        });
      }

      // Initialize reCAPTCHA with longer delay to ensure script is fully loaded
      setTimeout(() => {
        if (typeof ReCaptchaManager !== 'undefined') {
          ReCaptchaManager.renderCaptcha('page-contact-recaptcha', 'page-contact-recaptcha-error');
        }
      }, 1500);
    },

    getDeviceType: function() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
        return 'Tablet';
      }
      if (/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(userAgent)) {
        return 'Mobile';
      }
      return 'Desktop';
    },

    getBrowserName: function() {
      const userAgent = navigator.userAgent;
      let browserName = 'Unknown';

      if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
        browserName = 'Opera';
      } else if (userAgent.indexOf('Edg') > -1) {
        browserName = 'Edge';
      } else if (userAgent.indexOf('Chrome') > -1) {
        browserName = 'Chrome';
      } else if (userAgent.indexOf('Safari') > -1) {
        browserName = 'Safari';
      } else if (userAgent.indexOf('Firefox') > -1) {
        browserName = 'Firefox';
      } else if (userAgent.indexOf('Trident') > -1) {
        browserName = 'Internet Explorer';
      }

      return browserName;
    },

    addContactFormStyles: function() {
      // Only add styles if they don't exist yet
      if (!document.getElementById('contact-page-form-styles')) {
        const styleElement = document.createElement('style');
        styleElement.id = 'contact-page-form-styles';
        styleElement.textContent = `
          .contact-page-form {
            max-width: 600px;
            margin: 0 auto;
            padding: 30px;
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          }

          .contact-form-header {
            margin-bottom: 30px;
          }

          .contact-form-title {
            font-size: 28px;
            margin: 0 0 10px 0;
            color: #333;
            font-weight: 600;
          }

          .contact-form-header p {
            color: #666;
            margin: 0;
            font-size: 16px;
          }

          .contact-form-row {
            display: flex;
            gap: 15px;
            margin-bottom: 15px;
          }

          .contact-form-field {
            flex: 1;
          }

          .contact-form-field.full-width {
            flex: none;
            width: 100%;
          }

          .field-label {
            display: block;
            font-size: 14px;
            color: #333;
            margin-bottom: 5px;
            font-weight: 500;
            text-align: start;
          }

          .contact-form-field input,
          .contact-form-field select,
          .contact-form-field textarea {
            width: 100%;
            padding: 12px 15px;
            border: 1px solid #ddd;
            border-radius: 5px;
            font-size: 14px;
            box-sizing: border-box;
            font-family: inherit;
          }

          .contact-form-field textarea {
            resize: vertical;
            min-height: 80px;
          }

          .contact-form-field input:focus,
          .contact-form-field select:focus,
          .contact-form-field textarea:focus {
            outline: none;
            border-color: #2c5aa0;
          }

          .contact-form-field input.error,
          .contact-form-field select.error,
          .contact-form-field textarea.error {
            border-color: #ff3333;
          }

          .field-error {
            display: block;
            color: #ff3333;
            font-size: 12px;
            margin-top: 5px;
          }

          .phone-input-container {
            display: flex;
            gap: 5px;
          }

          .country-code-static {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 72px;
            flex: 0 0 72px;
            flex-shrink: 0;
            line-height: 1;
            -webkit-user-select: none;
            user-select: none;
          }

          .phone-input-container select {
            flex: 1;
          }

          .phone-input-container input {
            flex: 3;
          }

          .contact-form-checkbox {
            margin: 15px 0 20px;
          }

          .contact-form-checkbox label {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #666;
            cursor: pointer;
          }

          .contact-form-checkbox input[type='checkbox'] {
            margin-right: 8px;
          }

          .contact-method-section {
            margin: 20px 0;
            /* Page container may set text-align: center; keep the block left-aligned */
            text-align: left;
          }

          .section-label {
            display: block;
            font-size: 14px;
            color: #333;
            margin-bottom: 10px;
            font-weight: 500;
            text-align: left;
          }

          .contact-method-options {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
          }

          .radio-option {
            display: flex;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            color: #666;
          }

          .radio-option input[type='radio'] {
            margin-right: 6px;
            margin-top: 0;
          }

          .recaptcha-container {
            margin: 20px 0;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }

          .contact-submit-btn {
            width: 100%;
            background-color: #ff3333;
            color: white;
            border: none;
            padding: 15px;
            border-radius: 5px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            margin-top: 10px;
          }

          .contact-submit-btn:hover {
            background-color: #8a3a37;
          }

          .contact-submit-btn:disabled {
            background-color: #ccc;
            cursor: not-allowed;
          }

          /* Mobile Responsive */
          @media (max-width: 768px) {
            .contact-page-form {
              padding: 20px;
              margin: 10px;
            }

            .contact-form-row {
              flex-direction: column;
              gap: 10px;
            }

            .contact-form-title {
              font-size: 24px;
            }

            .contact-method-options {
              flex-direction: column;
              gap: 10px;
            }

            .phone-input-container {
              flex-direction: row;
            }

            .country-code-static {
              width: 64px;
              flex: 0 0 64px;
            }
          }
        `;
        document.head.appendChild(styleElement);
      }
    }
  };

  // =============================================================================
  // Contact Page Form Handler Functions
  // =============================================================================

  // UTM Parameter Handler (reuse from modal)
  function getUtmParams() {
    // Extended to capture Google Ads attribution parameters alongside core UTMs
    const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'gbraid', 'wbraid', 'msclkid'];
    const urlParams = new URLSearchParams(window.location.search);
    const result = {};

    KEYS.forEach((key) => {
      if (urlParams.has(key)) {
        const val = urlParams.get(key);
        if (val) {
          result[key] = val;
          sessionStorage.setItem(key, val);
        } else {
          sessionStorage.removeItem(key);
        }
      } else {
        const storedVal = sessionStorage.getItem(key);
        if (storedVal) {
          result[key] = storedVal;
        }
      }
    });

    return result;
  }

  // API submission function (reuse from modal)
  async function submitFormToAPI(payload) {
    try {
      // Ensure VPN detection runs before API submission
      if (typeof window.ensureVpnResolved === 'function') {
        await window.ensureVpnResolved();
      }

      const isVpnValue = typeof payload.isVpn !== 'undefined' ? !!payload.isVpn : !!(window.__leadContext && window.__leadContext.isVpn);
      const vpnStatusValue = payload.vpn_status || (isVpnValue ? 'detected' : 'not_detected');

      const apiPayload = {
        form_type: payload.form_type,
        first_name: payload.first_name,
        last_name: payload.last_name,
        email: payload.email,
        phone: payload.phone,
        page_url: window.location.href,
        utf8: "✓",
        utm_source: payload.utm_source || '',
        utm_medium: payload.utm_medium || '',
        utm_campaign: payload.utm_campaign || '',
        // Extended attribution parameters
        gclid: payload.gclid || '',
        gbraid: payload.gbraid || '',
        wbraid: payload.wbraid || '',
        msclkid: payload.msclkid || '',
        body: payload.body || 'No description provided',
        preferred_contact: payload.preferred_contact,
        device: payload.device || '',
        browser: payload.browser || '',
        ip_address: payload.ip_address || '',
        isVpn: isVpnValue,
        vpn_detected: isVpnValue,
        vpn_detected_text: String(isVpnValue),
        vpn_status: vpnStatusValue,
      };

      console.log("Sending to API:", apiPayload);

      const result = await window.LeadSubmissionManager.submitLead(apiPayload);
      if (result.queued) {
        console.log("Lead captured locally for background delivery");
      } else {
        console.log("Lead created successfully:", result.leadId);
      }
    } catch (error) {
      console.error("Error submitting form to API:", error);
      throw error;
    }
  }

  // =============================================================================
  // Contact Page Form Validation Helpers
  // =============================================================================
  function pageContactValidateEmail(email) {
    if (!email || typeof email !== 'string') return false;
    email = email.trim();
    if (!email.includes('@')) return false;
    const parts = email.split('@');
    if (parts.length !== 2) return false;
    const [localPart, domainPart] = parts;
    if (!localPart || localPart.length === 0) return false;
    if (!domainPart || domainPart.length === 0) return false;
    if (!domainPart.includes('.')) return false;
    const domainParts = domainPart.split('.');
    const tld = domainParts[domainParts.length - 1];
    if (!tld || tld.length < 2) return false;
    return /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  }

  function pageContactValidateEmailField(emailInput, errorSpan) {
    const email = emailInput.value.trim();
    if (email === '') {
      emailInput.classList.remove('error');
      errorSpan.style.display = 'none';
      return true;
    }
    const isValid = pageContactValidateEmail(email);
    if (isValid) {
      emailInput.classList.remove('error');
      errorSpan.style.display = 'none';
    } else {
      emailInput.classList.add('error');
      errorSpan.style.display = 'block';
    }
    return isValid;
  }

  function pageContactValidatePhone(phone, countryCode = '') {
    if (!phone || typeof phone !== 'string') return false;
    const trimmed = phone.trim();
    if (!trimmed) return false;
    if (/[a-zA-Z]/.test(trimmed)) return false;
    if (/[^0-9 +().\-]/.test(trimmed)) return false;
    const digits = (countryCode + trimmed).replace(/[^0-9]/g, '');
    return digits.length > 10;
  }

  function pageContactValidatePhoneField(phoneInput, errorSpan) {
    const phone = phoneInput.value.trim();
    if (phone === '') {
      phoneInput.classList.remove('error');
      errorSpan.style.display = 'none';
      return true;
    }
    const countryCode = phoneInput.form.querySelector('[name="country_code"]')?.value || '';
    const isValid = pageContactValidatePhone(phone, countryCode);
    if (isValid) {
      phoneInput.classList.remove('error');
      errorSpan.style.display = 'none';
    } else {
      phoneInput.classList.add('error');
      errorSpan.style.display = 'block';
    }
    return isValid;
  }

  // Page contact form submit handler (main-style: submit to app endpoint + Zapier)
  async function handlePageContactFormSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const submitButton = form.querySelector('.contact-submit-btn');

    console.log('Page contact form submitted');

    // Validate email
    const emailInput = form.querySelector('#page-contact-email-input');
    const emailError = form.querySelector('#page-contact-email-error');
    if (emailInput && emailError) {
      const isEmailValid = pageContactValidateEmailField(emailInput, emailError);
      if (!isEmailValid) {
        emailInput.focus();
        return;
      }
    }

    // Validate phone (only if a value was entered)
    const phoneInput = form.querySelector('#page-contact-phone-input');
    const phoneError = form.querySelector('#page-contact-phone-error');
    if (phoneInput && phoneError && phoneInput.value.trim()) {
      const isPhoneValid = pageContactValidatePhoneField(phoneInput, phoneError);
      if (!isPhoneValid) {
        phoneInput.focus();
        return;
      }
    }

    // Validate reCAPTCHA
    const recaptchaResponse = ReCaptchaManager
      ? ReCaptchaManager.validateCaptcha('page-contact-recaptcha-error', 'page-contact-recaptcha')
      : true;

    console.log('reCAPTCHA response:', recaptchaResponse);

    if (!recaptchaResponse) {
      console.log('reCAPTCHA validation failed');
      return;
    }

    // Disable submit button
    submitButton.disabled = true;
    submitButton.textContent = 'Submitting...';

    // Ensure VPN detection is resolved
    await ensureVpnResolved();
    const isVpn = !!window.__leadContext?.isVpn;
    const vpnStatus = isVpn ? 'detected' : 'not_detected';

    try {
      // Prepare form data
      const formData = new FormData(form);
      const payload = {};

      // Convert FormData to object, handling contact[] format
      for (let [key, value] of formData.entries()) {
        const match = key.match(/contact\[(.*?)\]/);
        if (match && match[1]) {
          payload[match[1]] = value;
        } else {
          payload[key] = value;
        }
      }

      // Get UTM parameters (they should already be in payload from form fields)
      const utmData = getUtmParams();
      // Prefer current URL/sessionStorage over stale form hidden values
      payload.utm_source = utmData.utm_source || payload.utm_source || '';
      payload.utm_medium = utmData.utm_medium || payload.utm_medium || '';
      payload.utm_campaign = utmData.utm_campaign || payload.utm_campaign || '';
      payload.gclid = utmData.gclid || payload.gclid || '';
      payload.gbraid = utmData.gbraid || payload.gbraid || '';
      payload.wbraid = utmData.wbraid || payload.wbraid || '';
      payload.msclkid = utmData.msclkid || payload.msclkid || '';

      // Split full_name into first_name and last_name
      if (payload.full_name) {
        const nameParts = payload.full_name.trim().split(/\s+/);
        if (nameParts.length === 1) {
          payload.first_name = nameParts[0];
          payload.last_name = '';
        } else if (nameParts.length >= 2) {
          payload.first_name = nameParts[0];
          payload.last_name = nameParts.slice(1).join(' ');
        }
        delete payload.full_name;
      }

      // Combine country code and phone number
      if (payload.country_code && payload.phone) {
        payload.phone = payload.country_code + ' ' + payload.phone;
        delete payload.country_code;
      }

      // Add timestamp and additional info
      payload.timestamp = new Date().toISOString();
      payload.page_url = window.location.href;
      payload.referrer = document.referrer || '';
      payload.user_agent = navigator.userAgent;
      payload.subject = `Contact Inquiry - ${payload.product_title || 'General Inquiry'}`;
      payload.form_source = 'contact_page';

      // Add reCAPTCHA response if available
      if (typeof recaptchaResponse === 'string') {
        payload.recaptcha_response = recaptchaResponse;
      }

      // VPN fields
      payload.isVpn = isVpn;
      payload.vpn_detected = isVpn;
      payload.vpn_detected_text = String(isVpn);
      payload.vpn_status = vpnStatus;

      // Add VPN indicator for Zapier
      if (isVpn) {
        payload['(VPN)'] = '(VPN)';
      }

      // Ensure IP address is properly set
      const detectedIP = VPNDetectionManager?.userIP || IPAddressManager?.userIP || payload['ip_address'] || '';
      payload.ip_address = detectedIP;
      payload.user_ip = detectedIP;

      console.log('Page contact form payload:', payload);
      console.log('UTM data extracted:', {
        utm_source: payload.utm_source,
        utm_medium: payload.utm_medium,
        utm_campaign: payload.utm_campaign,
        device: payload.device,
        browser: payload.browser
      });

      // Submit to API
      await submitFormToAPI(payload);

      // Submit to Zapier (use env-configured URL)
      const zapierWebhookUrl = window.__leadConfig && window.__leadConfig.isProd
        ? window.__leadConfig.zapierUrlProd
        : window.__leadConfig.zapierUrlStaging;

      console.log('Sending to Zapier:', payload);

      await fetch(zapierWebhookUrl, {
        method: 'POST',
        body: JSON.stringify(window.LeadSubmissionManager.normalizeLeadFields(payload)),
        mode: 'no-cors',
      });

      console.log('Page contact form sent to Zapier');
      // Redirect based on VPN status
      const redirectUrl = isVpn ? '/pages/thank-you-vpn?noconv=1' : '/pages/thank-you-for-contacting-us';
      window.location.href = redirectUrl;

    } catch (error) {
      console.error('Page contact form error:', error);
      alert('There was an error submitting the form. Please try again.');
      submitButton.disabled = false;
      submitButton.textContent = 'Submit';
      if (typeof ReCaptchaManager !== 'undefined') {
        ReCaptchaManager.resetCaptcha('page-contact-recaptcha');
      }
    }
  }

  // LEGACY CODE BELOW - KEPT FOR REFERENCE BUT NOT EXECUTED
  async function handlePageContactFormSubmit_LEGACY(event) {
    event.preventDefault();

    const form = event.target;
    const submitButton = form.querySelector('.contact-submit-btn');

    console.log('Page contact form submitted');

    // Validate reCAPTCHA
    const recaptchaResponse = ReCaptchaManager
      ? ReCaptchaManager.validateCaptcha('page-contact-recaptcha-error', 'page-contact-recaptcha')
      : true;

    console.log('reCAPTCHA response:', recaptchaResponse);

    if (!recaptchaResponse) {
      console.log('reCAPTCHA validation failed');
      return;
    }

    // Disable submit button
    submitButton.disabled = true;
    submitButton.textContent = 'Submitting...';

    // Ensure VPN detection is resolved
    await ensureVpnResolved();
    const isVpn = !!window.__leadContext?.isVpn;
    const vpnStatus = isVpn ? 'detected' : 'not_detected';

    // Resolve IP on-demand and mirror into the hidden input (optional but keeps form consistent)
    try {
      const ip = await IPAddressManager.getUserIP();
      const ipInput = form.querySelector('#contact-ip');
      if (ipInput) ipInput.value = ip;
    } catch (e) {
      // ignore; we'll fill user_ip later from manager or leave it empty
    }

    try {
      // Prepare form data
      const formData = new FormData(form);
      const payload = {};

      // Convert FormData to object, handling contact[] format
      for (let [key, value] of formData.entries()) {
        const match = key.match(/contact\[(.*?)\]/);
        if (match && match[1]) {
          // Extract the field name from contact[fieldname] format
          payload[match[1]] = value;
        } else {
          payload[key] = value;
        }
      }

      // Get UTM parameters (they should already be in payload from form fields)
      const utmData = getUtmParams();
      // Prefer current URL/sessionStorage over stale form hidden values
      payload.utm_source = utmData.utm_source || payload.utm_source || '';
      payload.utm_medium = utmData.utm_medium || payload.utm_medium || '';
      payload.utm_campaign = utmData.utm_campaign || payload.utm_campaign || '';
      payload.gclid = utmData.gclid || payload.gclid || '';
      payload.gbraid = utmData.gbraid || payload.gbraid || '';
      payload.wbraid = utmData.wbraid || payload.wbraid || '';
      payload.msclkid = utmData.msclkid || payload.msclkid || '';

      // Split full_name into first_name and last_name
      if (payload.full_name) {
        const nameParts = payload.full_name.trim().split(/\s+/);
        if (nameParts.length === 1) {
          payload.first_name = nameParts[0];
          payload.last_name = '';
        } else if (nameParts.length >= 2) {
          payload.first_name = nameParts[0];
          payload.last_name = nameParts.slice(1).join(' ');
        }
        delete payload.full_name;
      }

      // Combine country code and phone number
      if (payload.country_code && payload.phone) {
        payload.phone = payload.country_code + ' ' + payload.phone;
        delete payload.country_code;
      }

      // Add timestamp and additional info
      payload.timestamp = new Date().toISOString();
      payload.page_url = window.location.href;
      payload.referrer = document.referrer || '';
      payload.user_agent = navigator.userAgent;
      // Subject will be set after VPN detection
      payload.form_source = 'contact_page';

      // Add reCAPTCHA response if available
      if (typeof recaptchaResponse === 'string') {
        payload.recaptcha_response = recaptchaResponse;
      }

      // VPN fields
      payload.isVpn = isVpn;                              // New field name for consistency
      payload.vpn_detected = isVpn;                       // Keep for backward compatibility
      payload.vpn_detected_text = String(isVpn);          // 'true'/'false' for text filters
      payload.vpn_status = vpnStatus;

      // Ensure IP address is properly set
      const detectedIP = VPNDetectionManager?.userIP || IPAddressManager?.userIP || payload['ip_address'] || '';
      payload.ip_address = detectedIP;
      payload.user_ip = detectedIP;

      // Subject tagging
      const baseSubject = `Contact Inquiry - ${payload.product_title || 'General Inquiry'}`;
      payload.subject = isVpn ? `${baseSubject} (VPN)` : baseSubject;

    console.log('Page contact form payload:', payload);
      console.log('UTM data extracted:', {
        utm_source: payload.utm_source,
        utm_medium: payload.utm_medium,
        utm_campaign: payload.utm_campaign,
        device: payload.device,
        browser: payload.browser
      });

      // Submit to API
      await submitFormToAPI(payload);

      // Submit to Zapier
      // const zapierWebhookUrl = 'https://hooks.zapier.com/hooks/catch/5398638/2xcqua5/'; // Production webhook - commented out
      const zapierWebhookUrl = 'https://hooks.zapier.com/hooks/catch/21948283/uhrmxab/'; // Staging webhook

      console.log('Sending to Zapier:', payload);

      await fetch(zapierWebhookUrl, {
        method: 'POST',
        body: JSON.stringify(window.LeadSubmissionManager.normalizeLeadFields(payload)),
        mode: 'no-cors',
      });

      console.log('Page contact form sent to Zapier');

      // Use centralized success handler
      handleLeadSuccess({
        formType: 'contact',
        isVpn: isVpn,
        redirectUrl: '/pages/thank-you-for-contacting-us',
        neutralUrl: '/pages/thank-you-vpn?noconv=1'
      });

    } catch (error) {
      console.error('Page contact form error:', error);
      alert('There was an error submitting the form. Please try again.');
      submitButton.disabled = false;
      submitButton.textContent = 'Submit';
      if (typeof ReCaptchaManager !== 'undefined') {
        ReCaptchaManager.resetCaptcha('page-contact-recaptcha');
      }
    }
  }


// Preserve the previous DOM-ready initialization while supporting Theme Editor reloads.
function initContactPageModule() {
  ContactPageForm.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactPageModule);
} else {
  initContactPageModule();
}

document.addEventListener('shopify:section:load', function(event) {
  if (event.target && event.target.querySelector('#contact-form')) {
    ContactPageForm.init();
  }
});

window.ContactPageForm = ContactPageForm;
window.handlePageContactFormSubmit = handlePageContactFormSubmit;
